import Service, { inject as service } from "@ember/service"

export default class Persister extends Service {
  @service("ember-store") store

  @service socket

  init() {
    super.init(...arguments)
    this.queue = []
    this.lastActionId = null
    this.publishedActionCount = 0
  }

  persist(actionDoc) {
    this.socket.publish(actionDoc)
  }
}
